<template>
    <div class="nmodule">
        <ntitle :link="link">
            {{ title }}
            <template slot="control">
                <slot name="control"></slot>
            </template>
        </ntitle>
        <div class="modu">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import ntitle from './ntitle.vue';

export default {
    components: {
        ntitle
    },
    props: {
        title: {
            type: String,
            default: ""
        },
        link: {
            type: String,
            default: ""
        }
    }
}
</script>

<style lang="scss" scoped>
.nmodule {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .modu {
        height: calc(100% - 2.5rem);
        width: 100%;
        // background: url(../../assets/newscreen/bg_module_1.png) no-repeat;
        background-size: 100% 100%;
    }
}
</style>